import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';


const useDeleteWithConfirmation = (deleteApiUrl, fetchData, clearFields, setClickedAnyIcon) => {

  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const location = useLocation();
  const currentPage = location.pathname;


  const handleButtonDelete = (id) => {
    setDeleteId(id);
    setIsDeletePopupOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      // JWT-Token aus dem localStorage holen
      const access_token = localStorage.getItem('access_token');

      // DELETE-Anfrage mit Bearer-Token im Header
      const response = await axios.delete(deleteApiUrl, {
        headers: {
          'Authorization': `Bearer ${access_token}`
        },
        params: { id: deleteId } // ID des zu loeschenden Datensatzes
      });

      // nur auf machine_configurationPage:
      if (currentPage === '/knittingmachineconfiguration') {
        // Auffrischen der id_machinetype beim Löschen einer Maschinenkonfiguration, 
        // da sonst undefined und die Tabelle dadurch leer angezeigt wird (nach Aufruf fetchMachineConfiguration)
        const refreshIdMachinetype = response.data.id_machinetype;
        window.localStorage.setItem('id_machinetype', refreshIdMachinetype);
      }

      fetchData();
      clearFields();
      setClickedAnyIcon(false);
    } catch (error) {
      console.error('Error deleting the record:', error);
    } finally {
      // Popup schließen, egal ob erfolgreich oder nicht
      setIsDeletePopupOpen(false);
    }
  };

  const closeDeletePopup = () => {
    setIsDeletePopupOpen(false);
  };

  // hier wird alles nacheinander abgerufen
  return {
    isDeletePopupOpen,
    handleButtonDelete,
    handleConfirmDelete,
    closeDeletePopup,
  };
};

export default useDeleteWithConfirmation;
